// extracted by mini-css-extract-plugin
export default {"record":"Recording_record__Vnzhm","deleteIconContainer":"Recording_deleteIconContainer__T0jl0"};